import { render, staticRenderFns } from "./Drenthe.vue?vue&type=template&id=3caa7c4f&"
var script = {}
import style0 from "./Drenthe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Drenthe.vue"
export default component.exports